import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';


@Component({
  selector: 'app-banner-configuration',
  templateUrl: './banner-configuration.component.html',
  styleUrls: ['./banner-configuration.component.scss']
})




export class BannerConfigurationComponent extends FeaturesBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
